<script setup>
import {onMounted, ref} from 'vue';
import {useRouter, useRoute} from 'vue-router';
import {definePage} from "unplugin-vue-router/runtime";
import logoWhite from "@/assets/logo_full_white.svg"

import createApiService from '@/services/api';

const router = useRouter();
const route = useRoute();
const api = createApiService(router);

definePage({
  meta: {
    title: 'Wachtwoord vergeten',
    requiresAuth: false,
  },
})

const loading = ref(false);
const email = ref('');
const message = ref('');
const errors = ref([]);
const initialLoadComplete = ref(false);

const requestPassword = async () => {
  loading.value = true;
  resetMessages();

  try {
    const response = await api.post('login', {emailforgotten: email.value});

    if (response.status === 200) {
      message.value = response.data.message;
    }
    else {
      errors.value = ['Er is iets misgegaan. Probeer het later nog eens.'];
    }
  } catch (e) {
    errors.value = e.response?.status === 400 ? [e.response.data.message] : ['Er is iets misgegaan. Probeer het later nog eens.'];
  } finally {
    loading.value = false;
  }
}

const resetMessages = () => {
  message.value = "";
  errors.value = [];
}

onMounted(async () => {
  initialLoadComplete.value = true;
});
</script>

<template>
  <the-loader v-if="loading"/>

  <v-card
    class="ma-auto pa-5"
    color="primary"
    :disabled="loading"
    max-width="500"
  >

    <v-img :src="logoWhite" max-width="50%" class="mx-auto mb-12"></v-img>

    <v-form
      v-if="initialLoadComplete"
      @submit.prevent="requestPassword"
    >
      <v-card-text class="pl-0 pr-0">

        <v-alert
          v-if="message.length"
          class="mx-auto mb-5"
          max-width="500"
          color="success"
          variant="elevated"
        >
          {{message}}
        </v-alert>

        <v-alert
          v-if="errors.length"
          class="mx-auto mb-5"
          max-width="500"
          color="error"
          variant="elevated"
        >
          <template #text>
            <span
              v-for="(error, index) in errors"
              :key="index"
            >
              {{ error }}
            </span>
          </template>
        </v-alert>

        <div class="mb-4">
          <h4 class="mb-2">E-mailadres</h4>
          <v-text-field
            v-model="email"
            placeholder="E-mailadres"
            variant="solo"
            hide-details
          />
        </div>

      </v-card-text>

      <v-card-actions class="flex-column ma-auto pa-0 mt-2 actions">
        <v-btn
          class="mb-2 w-100"
          height="54"
          type="submit"
          color="secondary"
          variant="elevated"
          block
        >
          <h4>Wachtwoord aanvragen</h4>
        </v-btn>
      </v-card-actions>
    </v-form>

    <div
      v-else
      class="text-center py-10"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>

    <div class="bottom-link text-center w-100 pb-4 mt-8">
      <p class="p-small">Heb je al een account?</p>
      <a href="/inloggen" class="text-white">
        Log in
      </a>
    </div>
  </v-card>


</template>

<style scoped>

.actions {
  min-height: auto;
}

</style>
